module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<header>\r\n    <h3 class="hea_img_lo">\r\n        <a target="_blank" href="http://www.coresolutions.es/">\r\n            <img style=" width: 250px" type="icon" id="logo" class="img-responsive" alt="'+
((__t=(attributes.MAINTITLE))==null?'':_.escape(__t))+
'" src="' + require("C:\\xampp\\htdocs\\wwwcoreinvent\\node_modules\\underscore-template-loader\\file-loader.js?url=..%2F..%2Fresources%2Flogocore.png!../../resources/logocore.png") + '">\r\n        </a>\r\n    </h3>\r\n</header>\r\n<div class="container login">\r\n    <div class="row">\r\n        <div class="col-xs-4 col-xs-offset-4">\r\n            <form class="form-signin" id="forgotForm">\r\n                <h2 class="form-signin-heading"><b>'+
((__t=(attributes.RECOVER_PASS))==null?'':_.escape(__t))+
'</b></h2>\r\n                <div class="form-group">\r\n                    <label for="username">'+
((__t=(attributes.INSERT_MAIL))==null?'':_.escape(__t))+
'</label>\r\n                    <input type="email" class="form-control" name="username" id="username" placeholder="Email" required autofocus="" />\r\n                </div>\r\n                <div class="form-group">\r\n                    <button class="btn btn-lg btn-primary btn-block" type="submit">'+
((__t=(attributes.SEND))==null?'':_.escape(__t))+
'</button>\r\n                </div>\r\n                <div class="form-group alert alert-info">\r\n                    '+
((__t=(attributes.RECOVER_INFO))==null?'':_.escape(__t))+
'\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/views/login/forgotView.ejs
// module id = 426
// module chunks = 0